import { setup } from './logger';
import type { OutlineDetail } from './types';

await setup();

const targetElement = document.getElementById('outlineViewer');

if (targetElement) {
    const templateJSON = (id: string) => {
        const element = document.getElementById(id);
        if (!element) {
            return {};
        }
        const content = element.textContent || '{}';
        return JSON.parse(content);
    };

    const data: OutlineDetail = templateJSON('data');
    const dicomweb = data.dicomweb;
    if (dicomweb != undefined) {
        const { submissionUrl, caseUrl } = data;
        if (caseUrl && submissionUrl) {
            // we're comparing the submission to a case
            import('./pages/Viewer2Full').then(function (Viewer2Full) {
                Viewer2Full.render(targetElement, dicomweb, submissionUrl, caseUrl);
            });
        } else if (submissionUrl) {
            // we're just looking at a submission
            import('./pages/Viewer2Full').then(function (Viewer2Full) {
                Viewer2Full.render(targetElement, dicomweb, submissionUrl, null);
            });
        } else {
            import('./pages/Viewer2').then(function (Viewer2) {
                Viewer2.render(targetElement, dicomweb);
            });
        }
    }
}
